// extracted by mini-css-extract-plugin
export var cartContainer = "_ne-4";
export var gray = "_ne-1";
export var itemContainer = "_ne-2";
export var itemDetails = "_ne-3";
export var strong = "_ne-0";